export function getRandomIndex (arr) {
  return Math.floor(Math.random() * arr.length)
}

export function getRandomItem (arr) {
  return arr[getRandomIndex(arr)]
}

export function removeRandomItem (arr) {
  return arr.splice(getRandomIndex(arr), 1)[0]
}

export function removeItem (arr, item) {
  return arr.splice(arr.indexOf(item), 1)[0]
}
